// @flow

import React, { Suspense, type Node } from 'react';
import ErrorBoundary from 'app/packages/safe-suspense/ErrorBoundary';

type Props = {|
  children: Node, // React elements containing a lazy component.
  fallback?: Node, // loading fallback. default is null.
|};

// Suspense (https://reactjs.org/docs/code-splitting.html#suspense) renders fallback while waiting
// for the lazy comopnent to load, whereas ErrorBoundary can safely recover from a network error.
export default function SafeSuspense({ fallback, children }: Props) {
  const loadingFallback = fallback || null;
  if (__SERVER__) {
    return loadingFallback; // ReactDOMServer does not yet support Suspense.
  }
  return (
    <ErrorBoundary>
      <Suspense fallback={loadingFallback}>{children}</Suspense>
    </ErrorBoundary>
  );
}
